import React, { Fragment } from 'react';
import { Field } from 'react-final-form'
import AWS from 'aws-sdk';

import { TextField, Checkbox, Radio, Select } from 'final-form-material-ui';
import {
  RadioGroup,
  FormLabel,
  MenuItem,
  FormGroup,
  FormControl,
  FormControlLabel,
  CircularProgress,
} from '@material-ui/core';
import Dropzone from 'react-dropzone';

import './FormFields.css'
import metadata from '../metadata';

const S3 = new AWS.S3(metadata.s3.config);

export {
  formDate,
  formInput,
  formCheckbox,
  formRadio,
  formTextarea,
  formSelect,
  formFile,
}

function formInput(inName, inLabel, inRequired = true, inPlacehoder = '', inDisabled = false) {
  return (<Field
    fullWidth
    required={inRequired}
    name={inName}
    component={TextField}
    // placeholder={inPlacehoder}
    disabled={inDisabled || false}
    type="text"
    label={inLabel}
  />)
}

function formDate(inName, inLabel, inRequired = true, ) {
  return (
    <Field
        name={inName}
        component={TextField}
        fullWidth
        required={inRequired}
        type="date"
        margin="normal"
        label={inLabel}
        InputLabelProps={{
          shrink: true,
        }}
      />)
}

function formTextarea(inName, inLabel, inRequired = true, inPlacehoder = '') {
  return (<Field
    fullWidth
    name={inName}
    component={TextField}
    multiline
    className="textarea"
    required={inRequired}
    label={inLabel}
  />)
}

function formCheckbox(inName, inLabel, inRequired = true, inOptions, inPlacehoder = '') {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{inLabel}</FormLabel>
      <FormGroup row>
        {inOptions.map((option, index)=>{
              return (<FormControlLabel
                key={index}
                label={option.label}
                control={
                  <Field
                    name={inName}
                    component={Checkbox}
                    type="checkbox"
                    value={option.value}
                  />
                }
              />)
            })}
      </FormGroup>
    </FormControl>)
}

function formRadio(inName, inLabel, inRequired = true, inOptions, inPlacehoder = '', inDisabled = false) {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{inLabel}</FormLabel>
      <RadioGroup row>
        {inOptions.map((option, index)=>{
          return (<FormControlLabel
            key={index}
            label={option.label}
            control={
              <Field
                name={inName}
                disabled={inDisabled}
                required={inRequired}
                component={Radio}
                type="radio"
                value={option.value}
              />
            }
          />)
        })}
      </RadioGroup>
    </FormControl>)
}

function formSelect(inName, inLabel, inRequired = true, inOptions, inPlacehoder = '') {
  return (
    <Field
      fullWidth
      name={inName}
      component={Select}
      label={inLabel}
      required={inRequired}
      formControlProps={{ fullWidth: true }}
      >
        {inOptions.map((option, index)=>{
          return (<MenuItem key={index} value={option.value}>{option.label}</MenuItem>);
        })}
    </Field>);
}

function formFile(inName, inLabel, inRequired, inOptions, inPlacehoder = '', inDisabled, inForm) {
  let isUploading = false;
  const onDrop = (files, e) => {
    const email = inForm.values['email'];

    if (isUploading || !email) { return; }

    const file = files[0];
    isUploading = true;
    // upload and save the link.
    inForm.change(inName, 'Uploading...');
    inForm.blur(inName);

    const key = `jobs/files/${email}/${inName}.${file.name.split('.').pop()}`
    const params = {
      Body: file,
      Bucket: metadata.s3.bucket,
      Key: key,
      ContentType: file.type,
      ACL: 'public-read',
    };
    return S3.upload(params).promise()
      .then(() => {
        inForm.change(inName, key);
        inForm.blur(inName);
      })
      .catch(console.log)
      .finally(() => {
        isUploading = false;
      })
  };

  return (<Fragment>
    <Field name={inName}>
      {() => (
        <Fragment>
          <label>{inLabel}</label>
          <Dropzone onDrop={onDrop} accept={['image/*']}>
            {({getRootProps, getInputProps}) => {
              const isUploading = inForm.values[inName] === 'Uploading...';
              const link = (inForm.values[inName]) ? 
                `https://s3.amazonaws.com/summercamp-enrollments-2019/${inForm.values[inName]}` : null;
              return (<section>
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  {
                    !link && <div className="drop-zone">
                      {
                        (inForm.values && inForm.values[inName]) ?
                        `File - ${inForm.values[inName].split('/').pop()}`: 
                        `Drag 'n' drop files here, or click to select files (images only)`
                      }
                    </div>
                  }
                  {
                    isUploading &&
                    <div className="photo-container">
                      <CircularProgress size={30} thickness={6}/>
                    </div>
                  }
                  {
                    link && !isUploading &&
                    <div className="photo-container">
                      <img src={link} alt="Uploaded"/>
                    </div>
                  }
                </div>
              </section>)
            }}
          </Dropzone>
        </Fragment>
      )}
    </Field>
  </Fragment>)
}
